export function printTime(timespan: number): string {
    const seconds = (Math.floor(timespan / 1000) % 60).toString().padStart(2, "0");
    const minutes = (Math.floor(timespan / 1000 / 60) % 60).toString().padStart(2, "0");
    const hours = Math.floor(timespan / 1000 / 60 / 60)
        .toString()
        .padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
}
